export const HOST = [
    'https://ams-customer-us-test.tigerbrokers.net/infobase',
    'https://customer.tradeup.com/infobase',
    'https://ams-customer-us-test.tigerbrokers.net/infobase'
];

export const API = {
    // 获取可枚举的列表配置，根据key区分: https://apidocs.tigerfintech.com/repository/21/api/master/WEB%20API.json#/operations/get-api-v1-enmu
    getEnumConfig: '/api/v1/enum',
    // https://apidocs.tigerfintech.com/repository/21/api/master/WEB%20API.json#/operations/get-api-v1-static-id-type
    getIdTypeList: '/api/v1/static/id_type', // 获取开户可选证件类型列表
    getIdTypeInfo: '/api/v1/static/id_type/info', // 获取证件配置信息
    // https://apidocs.tigerfintech.com/repository/21/api/master/WEB%20API.json#/operations/get-api-v1-static-field
    getCountryList: '/api/v1/static/field/:field', // 获取国家列表
    // 全量国家列表
    getAllCountry: '/api/v1/static/field/country'
};

// 使用cg返回的数据，如果有牌照或者region等多种域名区分，需要在这里逐一展开
export function bindCG() {
    const cfg = CG_API.customerInfobase?.COMMON;

    cfg && HOST.fill(cfg);
}
